import {
  IPaginatedResponse,
  IProduct,
} from '@boma/administration-portal/shared/entities';
import { UnitType } from '@boma/shared/entities';
import { createAction, props } from '@ngrx/store';

export const loadProducts = createAction(
  '[Products] Load Products',
  props<{ nextPage?: number }>()
);

export const loadPage = createAction(
  '[Products] Load Page',
  props<{ nextPage?: number }>()
);

//TODO THIS IS INNIFICIENT, THERE SHOULD SIMPLY BE A PARAMETER ON THE API CALL
export const loadLocalPage = createAction(
  '[Products] Load Local Page',
  props<{ nextPage?: number }>()
);

export const loadProductsSuccess = createAction(
  '[Products] Load Products Success',
  props<{ payload: IPaginatedResponse<IProduct> }>()
);

export const loadProductsFailure = createAction(
  '[Products] Load Products Failure',
  props<{ error: any }>()
);

export const addProductImage = createAction(
  '[Products] Add Product Image',
  props<{ file: File }>()
);

export const addProductImageSuccess = createAction(
  '[Products] Add Product Image Success',
  props<{ imageId: string; file: File }>()
);

export const addProductImageFailure = createAction(
  '[Products] Add Product Image Failure',
  props<{ error: any }>()
);

export const loadLocalProducts = createAction(
  '[Products] Load Local Products',
  props<{ nextPage?: number }>()
);

export const searchProducts = createAction(
  '[Products] Search Products',
  props<{ query: string }>()
);

export const searchProductsSuccess = createAction(
  '[Products] Search Products Success',
  props<{ payload: IPaginatedResponse<IProduct> }>()
);

export const searchLocalProducts = createAction(
  '[Products] Search Local Products',
  props<{ query: string }>()
);

export const searchLocalProductsSuccess = createAction(
  '[Products] Search Local Product Success',
  props<{ payload: IPaginatedResponse<IProduct> }>()
);

export const loadLocalProductsSuccess = createAction(
  '[Products] Load Local Products Success',
  props<{ payload: IPaginatedResponse<IProduct> }>()
);

export const loadLocalProductsFailure = createAction(
  '[Products] Load Local Products Failure',
  props<{ error: any }>()
);

export const setToGlobal = createAction(
  '[Products] Set Product to Global',
  props<{ id: string }>()
);

export const setToGlobalSuccess = createAction(
  '[Products] Set Product to Global Success',
  props<{ payload: IProduct }>()
);

export const setToGlobalFailure = createAction(
  '[Products] Set Product to Global Failure',
  props<{ error: any }>()
);

export const loadProductDetails = createAction(
  '[Products] Load Product Details',
  props<{ id: string }>()
);

export const loadProductDetailsSuccess = createAction(
  '[Products] Load Product Details Success',
  props<{ product: any; id: string }>()
);

export const loadProductDetailsFailure = createAction(
  '[Products] Load Product Details Failure',
  props<{ error: any }>()
);

export const deleteProduct = createAction(
  '[Products] Delete Product',
  props<{ id: string }>()
);

export const deleteProductSuccess = createAction(
  '[Products] Delete Product Success',
  props<{ id: string }>()
);

export const deleteProductFailure = createAction(
  '[Products] Delete Product Failure',
  props<{ error: any }>()
);

export const removeMetadata = createAction(
  '[Products] Remove Product Metadata',
  props<{ meta: any }>()
);

export const addCategory = createAction(
  '[Product] Add Product Category',
  props<{ categoryId: string; category: any }>()
);

export const removeCategory = createAction(
  '[Products] Remove Product Category',
  props<{ category: any }>()
);

export const setBrand = createAction(
  '[Product] Set Product Brand',
  props<{ brandId: string }>()
);

export const removeTaxDefinition = createAction(
  '[Product] Remove Product Tax Defintion',
  props<{ taxDefinitionId: string }>()
);

export const removeTaxDefintionSuccess = createAction(
  '[Product] Remove Product Tax Defintion Success',
  props<{ product: IProduct }>()
);

export const removeTaxDefintionFailure = createAction(
  '[Product] Remove Product Tax Defintion Failure',
  props<{ error: any }>()
);

export const activateProduct = createAction('[Products] Activate Product');

export const deactivateProduct = createAction('[Products] Deactivate Product');

export const addProductCustomProperties = createAction(
  '[Products] Add Product Property',
  props<{ property: any }>()
);

export const updateProduct = createAction('[Products] Update Product');

export const updateProductSuccess = createAction(
  '[Products] Update Product Success',
  props<{ product: any }>()
);

export const updateProductFailure = createAction(
  '[Products] Update Product Failure',
  props<{ error: any }>()
);

export const setBarcode = createAction(
  '[Products] Set Product Barcode',
  props<{ barcode: string }>()
);

export const addCountryTaxDefinition = createAction(
  '[Product] Add Product Country Tax Defintion',
  props<{ taxDefinition: any }>()
);

export const setProductMeasurement = createAction(
  '[Products] Set Product Measurement',
  props<{ measurement: UnitType }>()
);

export const addCountryTaxDefinitionSuccess = createAction(
  '[Product] Add Product Country Tax Defintion Success',
  props<{ product: IProduct }>()
);

export const addCountryTaxDefinitionFailure = createAction(
  '[Product] Add Product Country Tax Defintion Failure',
  props<{ error: any }>()
);
